import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isPhoneLineSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';


const mapFilterData = (data: IPhoneLineSearchForm): IPhoneLineSearchPost | {} => {
  const newData: IPhoneLineSearchForm = {...data};
  if (isPhoneLineSearchFormEmpty(data) || data == undefined) { return {} };
  
  newData.unitType = '';

  if(newData.deleted === "false"){
    newData.removalDateTo = "";
    newData.removalDateFrom = "";
  }

  const removedUnusedFilters = filterNonEmptyValues(newData);
  return removedUnusedFilters;
}

const getAllPhoneLines = async ( {data} : {data: IPhoneLineSearchForm}): Promise<IGetPhoneLine> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;
  
  const response =  await axiosDefaultApi.post(`api/Search/Search/PhoneLines?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData);
  return response as unknown as IGetPhoneLine;
};

type QueryFnType = typeof getAllPhoneLines;

type UseGetAllPhoneLinesOptions = {
  data: IPhoneLineSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPhoneLines = ({data, config}: UseGetAllPhoneLinesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPhoneLines'],
    queryFn: () => getAllPhoneLines({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των τηλεφωνικών γραμμών.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};